import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogInput } from '@gh/core-ui';
import { UnpaidInvoiceInfo } from '@gh/builder-shared-data';
import { REGION_CODE } from '@gh/config';

export interface UnpaidInvoicesDialogData {
  unpaidInvoices: UnpaidInvoiceInfo[];
  productName: string;
  customMessage?: string;
  showProceedButton?: boolean;
}

@Component({
  standalone: false,
  selector: 'gh-unpaid-invoices-dialog',
  templateUrl: './unpaid-invoices-dialog.component.html',
  styleUrls: ['./unpaid-invoices-dialog.component.scss']
})
export class UnpaidInvoicesDialogComponent implements DialogInput<UnpaidInvoicesDialogData>, OnInit {
  displayedColumns: string[] = ['officeName', 'invoiceId', 'amount', 'status'];
  input: UnpaidInvoicesDialogData;

  constructor(
    public dialogRef: MatDialogRef<UnpaidInvoicesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) {}

  get data(): UnpaidInvoicesDialogData {
    return this.input || this.dialogData?.input || this.dialogData;
  }

  get currencyCode(): string {
    switch (REGION_CODE as string) {
      case 'au':
        return 'AUD';
      case 'nz':
        return 'NZD';
      case 'us':
        return 'USD';
      default:
        return 'AUD';
    }
  }

  get currencySymbol(): string {
    switch (REGION_CODE as string) {
      case 'au':
        return 'A$';
      case 'nz':
        return 'NZ$';
      case 'us':
        return '$';
      default:
        return 'A$';
    }
  }

  ngOnInit(): void {
    console.log('UnpaidInvoicesDialogComponent Data:', this.data);
  }

  onExport(): void {
    const headers = ['Office Name', 'Invoice ID', 'Amount', 'Status'];
    const rows = this.data.unpaidInvoices.map(i => [
      i.officeName,
      i.invoiceId,
      i.amount.toFixed(2),
      i.status
    ]);

    const csvContent = [
      headers.join(','),
      ...rows.map(r => r.join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `unpaid_invoices_${this.data.productName.replace(/\s+/g, '_')}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
